import { render, staticRenderFns } from "./RecipientContactCreate.vue?vue&type=template&id=9f2ce40c"
import script from "./RecipientContactCreate.vue?vue&type=script&lang=js"
export * from "./RecipientContactCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports